import React, { useState, useEffect } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { buildStyles } from './DashTheme';
import { useTheme } from './DashWidgets';

const NAV = {
  student: [
    { section: 'Overview' },
    { label: 'Dashboard',       path: '/dashboard',      icon: '📊' },
    { label: 'My Complaints',   path: '/complaints',     icon: '📋' },
    { label: 'New Complaint',   path: '/complaints/new', icon: '✏️' },
    { section: 'Community' },
    { label: 'Community Board', path: '/community',      icon: '🏛️' },
    { section: 'Account' },
    { label: 'Profile',         path: '/profile',        icon: '👤' },
  ],
  faculty: [
    { section: 'Overview' },
    { label: 'Dashboard',       path: '/dashboard',      icon: '📊' },
    { label: 'My Complaints',   path: '/complaints',     icon: '📋' },
    { label: 'New Complaint',   path: '/complaints/new', icon: '✏️' },
    { section: 'Community' },
    { label: 'Community Board', path: '/community',      icon: '🏛️' },
    { section: 'Account' },
    { label: 'Profile',         path: '/profile',        icon: '👤' },
  ],
  admin: [
    { section: 'Overview' },
    { label: 'Dashboard',         path: '/dashboard',                  icon: '📊' },
    { section: 'Complaints' },
    { label: 'Pending',           path: '/admin/pending-complaints',   icon: '⏳' },
    { label: 'Verified',          path: '/admin/verified-complaints',  icon: '✅' },
    { section: 'Community' },
    { label: 'Community Board',   path: '/community',                  icon: '🏛️' },
    { section: 'Reports' },
    { label: 'Monthly Report',    path: '/admin/report',               icon: '📄' },
    { label: 'Complaint History', path: '/admin/complaints-history',   icon: '📁' },
    { section: 'Account' },
    { label: 'Profile',           path: '/profile',                    icon: '👤' },
  ],
  super_admin: [
    { section: 'Overview' },
    { label: 'Dashboard',         path: '/dashboard',                  icon: '📊' },
    { section: 'Complaints' },
    { label: 'Pending',           path: '/admin/pending-complaints',   icon: '⏳' },
    { label: 'Verified',          path: '/admin/verified-complaints',  icon: '✅' },
    { section: 'Community' },
    { label: 'Community Board',   path: '/community',                  icon: '🏛️' },
    { section: 'Reports' },
    { label: 'Monthly Report',    path: '/admin/report',               icon: '📄' },
    { label: 'Complaint History', path: '/admin/complaints-history',   icon: '📁' },
    { section: 'Account' },
    { label: 'Profile',           path: '/profile',                    icon: '👤' },
  ],
  authority: [
    { section: 'Overview' },
    { label: 'Dashboard',          path: '/dashboard',                  icon: '📊' },
    { label: 'Assigned',           path: '/authority/assigned',         icon: '📌' },
    { section: 'Complaints' },
    { label: 'Complaints History', path: '/authority/complaints-history', icon: '📁' },
    { section: 'Reports' },
    { label: 'Admin Reports',      path: '/authority/reports',          icon: '📊' },
    { label: 'Monthly Report',     path: '/authority/report',           icon: '📄' },
    { section: 'Management' },
    { label: 'All Users',          path: '/authority/users',            icon: '👥' },
    { section: 'Account' },
    { label: 'Profile',            path: '/profile',                    icon: '👤' },
  ],
  higher_authority: [
    { section: 'Overview' },
    { label: 'Dashboard',            path: '/dashboard',                          icon: '📊' },
    { section: 'Users' },
    { label: 'All Users',            path: '/higher-authority/users',             icon: '👥' },
    { section: 'Management' },
    { label: 'Create Admin',         path: '/higher-authority/create-admin',      icon: '➕' },
    { label: 'Create Authority',     path: '/higher-authority/create-authority',  icon: '➕' },
    { label: 'Manage Admins',        path: '/higher-authority/admins',            icon: '🛡️' },
    { label: 'Manage Authorities',   path: '/higher-authority/authorities',       icon: '⚖️' },
    { section: 'Reports' },
    { label: 'Admin Reports',        path: '/higher-authority/admin-reports',     icon: '📊' },
    { label: 'Authority Reports',    path: '/higher-authority/authority-reports', icon: '📊' },
    { label: 'Performance',          path: '/higher-authority/performance',       icon: '📈' },
    { section: 'Escalations' },
    { label: 'Escalated Complaints', path: '/higher-authority/escalated',         icon: '⚠️' },
    { section: 'Account' },
    { label: 'Profile',              path: '/profile',                            icon: '👤' },
  ],
};

const ROLE_META = {
  student          : { mark: 'S',  label: 'Student Portal',          color: '#06b6d4' },
  faculty          : { mark: 'F',  label: 'Faculty Portal',          color: '#8b5cf6' },
  admin            : { mark: 'A',  label: 'Admin Portal',            color: '#f59e0b' },
  super_admin      : { mark: 'A',  label: 'Admin Portal',            color: '#f59e0b' },
  authority        : { mark: 'AU', label: 'Authority Portal',        color: '#6366f1' },
  higher_authority : { mark: 'HA', label: 'Higher Authority Portal', color: '#10b981' },
};

function useIsMobile() {
  const [mobile, setMobile] = useState(window.innerWidth <= 768);
  useEffect(() => {
    const handler = () => setMobile(window.innerWidth <= 768);
    window.addEventListener('resize', handler);
    return () => window.removeEventListener('resize', handler);
  }, []);
  return mobile;
}

export function HamburgerBtn({ onClick }) {
  return (
    <button onClick={onClick} style={{
      width: 36, height: 36, display: 'flex', flexDirection: 'column',
      alignItems: 'center', justifyContent: 'center', gap: 5,
      cursor: 'pointer', borderRadius: 9,
      background: 'rgba(255,255,255,0.12)',
      border: '1px solid rgba(255,255,255,0.2)',
      flexShrink: 0, padding: 0,
    }}>
      <div style={{ width: 16, height: 2, borderRadius: 2, background: '#fff' }} />
      <div style={{ width: 16, height: 2, borderRadius: 2, background: '#fff' }} />
      <div style={{ width: 16, height: 2, borderRadius: 2, background: '#fff' }} />
    </button>
  );
}

export default function Sidebar({ collapsed, onToggle, mobileOpen, onMobileClose }) {
  const { user, logout } = useAuth();
  const { theme } = useTheme();
  const s = buildStyles(theme);
  const navigate = useNavigate();
  const location = useLocation();
  const isMobile = useIsMobile();

  const role = user?.role || 'student';
  const meta = ROLE_META[role] || ROLE_META.student;
  const items = NAV[role] || NAV.student;

  if (!isMobile && collapsed) return null;

  const handleNav = (path) => {
    navigate(path);
    if (isMobile && onMobileClose) onMobileClose();
  };

  const sidebarStyle = {
    ...s.sidebar,
    ...(isMobile ? {
      position: 'fixed',
      top: 0, left: 0,
      transform: mobileOpen ? 'translateX(0)' : 'translateX(-100%)',
      transition: 'transform 0.28s cubic-bezier(0.4,0,0.2,1)',
      zIndex: 200,
      width: 272,
      boxShadow: mobileOpen ? '8px 0 40px rgba(0,0,0,0.5)' : 'none',
    } : {}),
  };

  return (
    <>
      {/* Mobile overlay */}
      {isMobile && mobileOpen && (
        <div onClick={onMobileClose} style={{
          position: 'fixed', inset: 0, zIndex: 199,
          background: 'rgba(0,0,0,0.65)', backdropFilter: 'blur(4px)',
          transition: 'opacity 0.28s',
        }} />
      )}

      <div style={sidebarStyle}>
        {/* Logo + close */}
        <div style={{
          ...s.sidebarLogo, justifyContent: 'space-between',
          padding: isMobile ? '18px 16px 14px' : '22px 20px 18px',
        }}>
          <div style={{ display: 'flex', alignItems: 'center', gap: 12, cursor: 'pointer', flex: 1, minWidth: 0 }}
            onClick={() => handleNav('/')}>
            <div style={{
              ...s.logoMark,
              background: `linear-gradient(135deg, ${meta.color}55, ${meta.color}22)`,
              border: `1px solid ${meta.color}44`,
              color: meta.color,
            }}>{meta.mark}</div>
            <div style={{ minWidth: 0 }}>
              <div style={s.logoText}>UniResolve</div>
              <div style={{ ...s.logoSub, color: meta.color + 'cc' }}>{meta.label}</div>
            </div>
          </div>

          {/* Desktop toggle */}
          {!isMobile && onToggle && (
            <button onClick={onToggle} title="Hide sidebar" style={{
              width: 32, height: 32, display: 'flex', flexDirection: 'column',
              alignItems: 'center', justifyContent: 'center', gap: 4,
              cursor: 'pointer', borderRadius: 8,
              background: 'rgba(255,255,255,0.1)',
              border: '1px solid rgba(255,255,255,0.18)',
              flexShrink: 0, padding: 0,
            }}>
              <div style={{ width: 14, height: 2, borderRadius: 2, background: '#fff' }} />
              <div style={{ width: 14, height: 2, borderRadius: 2, background: '#fff' }} />
              <div style={{ width: 14, height: 2, borderRadius: 2, background: '#fff' }} />
            </button>
          )}

          {/* Mobile close */}
          {isMobile && (
            <button onClick={onMobileClose} style={{
              width: 34, height: 34, borderRadius: 9,
              border: '1px solid rgba(255,255,255,0.2)',
              background: 'rgba(255,255,255,0.1)', color: '#fff', fontSize: 16,
              cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center',
              flexShrink: 0, transition: 'all 0.2s',
            }}>✕</button>
          )}
        </div>

        {/* Nav */}
        <nav style={{ flex: 1, overflowY: 'auto', padding: '6px 0' }}>
          {items.map((item, i) => {
            if (item.section) {
              return (
                <div key={i} style={{
                  ...s.navSection,
                  padding: isMobile ? '14px 16px 5px' : '18px 16px 6px',
                }}>{item.section}</div>
              );
            }
            const active = location.pathname === item.path;
            return (
              <div key={i} className="ur-nav-item"
                style={{
                  ...s.navItem,
                  ...(active ? s.navActive : {}),
                  padding: isMobile ? '11px 14px' : '9px 14px',
                  margin: isMobile ? '1px 10px' : '1px 10px',
                  gap: 10,
                }}
                onClick={() => handleNav(item.path)}>
                {item.icon && (
                  <span style={{ fontSize: 15, width: 20, textAlign: 'center', flexShrink: 0 }}>
                    {item.icon}
                  </span>
                )}
                <span style={{ fontSize: isMobile ? 14 : 13.5 }}>{item.label}</span>
                {active && <span style={{ ...s.navActiveDot, marginLeft: 'auto' }} />}
              </div>
            );
          })}
        </nav>

        {/* Footer */}
        <div style={{
          ...s.sidebarFoot,
          padding: isMobile ? '12px' : '14px',
        }}>
          <div style={{
            ...s.userChip,
            padding: isMobile ? '10px 12px' : '10px 12px',
            marginBottom: 10,
          }} onClick={() => handleNav('/profile')}>
            <div style={{
              ...s.avatar,
              width: isMobile ? 36 : 34, height: isMobile ? 36 : 34,
              background: `linear-gradient(135deg, ${meta.color}55, ${meta.color}22)`,
              border: `1px solid ${meta.color}44`,
              color: meta.color,
            }}>{user?.name?.[0]?.toUpperCase() || 'U'}</div>
            <div style={{ overflow: 'hidden', flex: 1 }}>
              <div style={{ ...s.userName, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', fontSize: isMobile ? 14 : 13 }}>
                {user?.name || 'User'}
              </div>
              <div style={{ ...s.userRole, fontSize: isMobile ? 12 : 11 }}>
                {user?.department || user?.role?.replace('_', ' ')}
              </div>
            </div>
          </div>
          <button className="ur-btn-hover"
            style={{ ...s.btnDanger, width: '100%', justifyContent: 'center', display: 'flex', gap: 6, padding: isMobile ? '10px 18px' : '9px 18px', fontSize: isMobile ? 14 : 13 }}
            onClick={() => logout(navigate)}>
            🚪 Sign Out
          </button>
        </div>
      </div>
    </>
  );
}
